(function (aimi_email_variants, $, app, undefined) {
  // Private object to hold module internals.
  let __this = {};

  class EmailVariantsEditor extends TableList {
    constructor(app, container) {
      super(app, container, null, null);
      this.app = app;
      this.container = container;
      this.categoriesContainer = $('[data-categories]', this.container);
      this.tabContentOptionsMenu = $('[data-menu="tab_content_options"]', this.container);
      this.tabSamplesMenu = $('[data-menu="tab_samples"]', this.container);
      this.tabSettingsMenu = $('[data-menu="tab_settings"]', this.container);
      this.render();
    }

    async renderCategories(businessProfileId) {
      this.categoriesContainer.empty();
      this.showCategoriesLoader();
      const categories = await this.app.apis['mdcdot_email_variants'].categories(businessProfileId);

      this.removeLoader();

      const page = _.template(app.templates['campaign__categories']);

      const merged = Utils.mergeDeep(categories.share, categories.promote);
      const $page = $(page({'categories': merged}));
      $page.appendTo(this.categoriesContainer);
      observerCampaignView();
      return $page;
    }

    showCategoriesLoader() {
      const loaderData = {
        id: '',
        name: this.staticPH,
        icon: "code",
        subcategories: [
          {id: '', name: this.staticPH, icon: "code"},
          {id: '', name: this.staticPH, icon: "code"},
          {id: '', name: this.staticPH, icon: "code"},
        ]
      };
      this.listRow = 'campaign__categories';
      this.showLoaderInto(this.categoriesContainer, {categories: [loaderData, loaderData, loaderData]}, 1);
    }

    getTabs(menus) {
      let tabs = {};
      menus.forEach(function (tab) {
        const key = tab.replace(/\s/g, "_").toLowerCase();
        tabs[key] = {'key': tab.replace(/\s/g, "_").replace('&', '').toLowerCase(), 'name': tab};
      })
      return tabs;
    }

    activateTabs($page) {
      const triggerTabList = [].slice.call($page.find('a.nav-link'));
      triggerTabList.forEach(function (triggerEl) {
        let tabTrigger = new bootstrap.Tab(triggerEl);
      })
    }

    renderCallToActions() {
      let mergeTag = {
        'id': 1,
        'tag': '{CALL_OPTION|}',
        'options': 'Text, Call, Call or text, Text message, custom',
        'text': 'Call or text',
        'cta': true,
      }
      let $el = Sample.createSelectField(mergeTag);
      $('[data-replace="{CALL_OPTION|}"]').replaceWith($el);

      mergeTag = {
        'id': 1,
        'tag': '{NUMBER|}',
        'text': '000-000-0000',
        'cta': true,
      }
      $el = Sample.createInputField(mergeTag);
      $('[data-replace="{NUMBER|}"]').replaceWith($el);

      mergeTag = {
        'id': 1,
        'tag': '{MEET_OPTION|}',
        'options': 'a consultation, a meeting,  an appointment, custom',
        'text': 'a consultation',
        'cta': true,
      }
      $el = Sample.createSelectField(mergeTag);
      $('[data-replace="{MEET_OPTION|}"]').replaceWith($el);

      mergeTag = {
        'id': 1,
        'tag': '{PM_OPTION|}',
        'options': 'PM, DM, Direct message, custom',
        'text': 'PM',
        'cta': true,
      }

      $el = Sample.createSelectField(mergeTag);
      $('[data-replace="{PM_OPTION|}"]').replaceWith($el);

    }

    async renderContentOptions() {
      const page = _.template(app.templates['campaign__tab_sub-menus']);
      const menus = [
        'Call to Actions',
        'Mentions'
      ];
      const $page = $(page({'menus': this.getTabs(menus), 'activeTab': 'Call to Actions'}));
      $page.appendTo(this.tabContentOptionsMenu);
      this.renderCallToActions();
      this.activateTabs($page);
      return $page;
    }

    renderMentions() {

    }

    async renderSamples() {
      const page = _.template(app.templates['campaign__tab_sub-menus']);
      const menus = [
        'Over 280 Character Samples',
        'Under 280 Character Samples'
      ];
      const $page = $(page({'menus': this.getTabs(menus), 'activeTab': 'Over 280 Character Samples'}));
      $page.appendTo(this.tabSamplesMenu);
      this.activateTabs($page);
      return $page;
    }

    initDaysSelect2($input) {
      const app = this.app;
      // Create a new Date object for the current date
      const today = new Date();
      // Get the day of the month using getDate()
      const dayOfMonth = today.getDate();

      $input.val(dayOfMonth);
      $input.select2({
        dropdownCssClass: 'font-select2-dropdown',
        selectionCssClass: 'font-select2-selection',
        theme: 'bootstrap-5'
      });
    }

    async renderSettings() {
      const page = _.template(app.templates['campaign__tab_sub-menus']);
      const menus = [
        'Frequency'
      ];
      const $page = $(page({'menus': this.getTabs(menus), 'activeTab': 'Frequency'}));
      $page.appendTo(this.tabSettingsMenu);

      return $page;
    }

    renderImageCollections(result) {
      const $container = $('[data-image-collections]', this.container);
      if (app.isEmpty(__this.renderedImageCollections)) {
        __this.renderedImageCollections = [];
      }

      let collections = app.clone(result);
      collections = Utils.getUniqueObjectsByKey(collections, 'id');

      const page = _.template(this.app.templates['image_library__collection-card']);
      _.each(collections, function (row) {
        if (app.isEmpty(__this.renderedImageCollections[row.id])) {
          __this.renderedImageCollections[row.id] = row;
          row.addButton = false;
          row.disabled = true;
          row.removeButton = true;
          const $card = ImageCollections.prepareCard(row, page, false);
          const $input = $('<input type="hidden" name="imageCollections[]" >');
          $input.val(row.id);
          $container.append($card);
          $card.append($input);

          let $images = $('[data-type="image"]', $card);
          $images.each(function (index, image) {
            if ($(image).attr('data-src') !== '') {
              __this.observerManager.observeIntersection(image);
            }
          });

          $card.find('[data-image-action="remove-from-campaign"]').off('click').on('click', function (e) {
            let $item = $(e.target).closest('.infinite-item');
            app.removeItem($item);
          })

          $card.find('[data-image-collection]').attr('data-campaign-action', 'view-collection');
        }
      });
    }

    renderImageTags(result) {
      const $container = $('[data-image-tags]', this.container);
      if (app.isEmpty(__this.renderedImageTags)) {
        __this.renderedImageTags = [];
      }

      const page = _.template(this.app.templates['image_library__row-tag']);
      _.each(result, function (row) {
        if (app.isEmpty(__this.renderedImageTags[row.id])) {
          __this.renderedImageTags[row.id] = row;
          row.addButton = false;
          row.disabled = true;
          row.actions = false;
          row.removeButton = true;
          const $card = ImageCollections.prepareCard(row, page, false);
          const $input = $('<input type="hidden" name="imageTags[]" >');
          $input.val(row.id);
          $container.append($card);
          $card.find('td').eq(0).append($input);

          $card.find('[data-image-action="remove-from-campaign"]').off('click').on('click', function (e) {
            let $item = $(e.target).closest('.tag-row');
            app.removeItem($item, 'bounceOutLeft');
          })

          let $images = $('[data-type="image"]', $card);
          $images.each(function (index, image) {
            if ($(image).attr('data-src') !== '') {
              __this.observerManager.observeIntersection(image);
            }
          });
          $card.find('[data-image-tag]').removeAttr('data-tag-action');
          $card.find('[data-image-tag]').attr('data-campaign-action', 'view-tag');
        }
      })
      ;
    }


    async renderFrequency() {
      // Initializes input spinner for numeric inputs
      $(`${__this.topContainer} .input-spinner-wrap input`).inputSpinner({buttonsOnly: true});
    }

    async render() {
      await this.renderContentOptions();
      await this.renderSamples();
      await this.renderFrequency();
      await this.renderSettings();
    }
  }

  aimi_email_variants.saveCallBack = function (response) {
    const self = aimi_email_variants.view;
    if (!app.isEmpty(__this.nextStep)) {
      if (app.isEmpty(__this.campaignId) && __this.nextStep === '#tab_email_variants_block_2') {
        __this.campaignId = response.id;
        app.localStorage.removeItem('next-step');
        self.refresh(__this.campaignId).then(function (response) {

        });
      }

      self.navigate(__this.nextStep);

      if (app.localStorage.getItem('build-email-variants')) {
        self.build().then(function (response) {
          response.onRenderList().then(function (response) {
            self.refresh(__this.campaignId).then(function (response) {
            });
          })
        });
      }

      if (__this.nextStep === '#tab_email_variants_block_4') {
        self.getCollectionsByCampaign(__this.campaignId).then(function (response) {
          if (!app.isEmpty(response.result)) {
            __this.campainEditor.renderImageCollections(response.result);
          }
        });
      }
    } else if (app.isEmpty(__this.nextStep)) {

    }
    // aimi_email_variants.view.refresh(response.id).then(function (response) {});
  }


  aimi_email_variants.contentOptionsPayloadProcessor = function (requestData) {

    let preferences = [];
    let blockgroups = [];
    const options = requestData.option;

    const switches = _.flatten(_.map(_.keys(requestData.switch), function (switchKey) {
      return _.map(switchKey.split(','), function (key) {
        return key.trim();
      });
    }));

    _.each(options, function (value, option) {
      const $input = $(`:input[name="option[${option}]"]`);

      let optionVal = {
        tag: option,
        value: value === 'on' ? true : value
      }

      if (value === 'custom') {
        optionVal.value = $input.data('custom-value');
      }

      if ($input.data('blockgroup')) {
        optionVal.blockgroup = $input.data('blockgroup');
        if (switches.includes(option)) {
          optionVal.enabled = true;
        }
        blockgroups.push(optionVal);
      } else {
        if ($input.data('cta') === option) {
          optionVal.cta = true;
          if (switches.includes(option)) {
            optionVal.enabled = true;
          }
        }
        preferences.push(optionVal);
      }
    });

    if (app.isEmpty(__this.campaign.config)) {
      __this.campaign.config = {};
    }

    if (app.isEmpty(__this.campaign.config.options)) {
      __this.campaign.config.options = {};
    }

    if (app.isEmpty(__this.campaign.config.blockgroups)) {
      __this.campaign.config.blockgroups = {};
    }

    if (
        Utils.isEqualIgnoringType(__this.campaign.config.options, preferences) &&
        Utils.isEqualIgnoringType(__this.campaign.config.blockgroups, blockgroups)

    ) {
      return false;
    } else {
      __this.campaign.config.options = preferences;
      __this.campaign.config.blockgroups = blockgroups;
    }

    return __this.campaign;
  }

  aimi_email_variants.samplesPayloadProcessor = function (requestData) {

    let mergeTags = [];

    if (app.isEmpty(__this.campaign.config)) {
      __this.campaign.config = {};
    }

    if (app.isEmpty(__this.campaign.config.mergeTags)) {
      __this.campaign.config.mergeTags = {};
    }

    const sampleContainers = $("[data-sample-container]");
    sampleContainers.each(function (index) {
      let sampleData = [];
      const sampleNav = $(this);
      const sampleTab = $(sampleNav.attr('data-bs-target'));
      const sample = new Sample(sampleTab);

      sampleData.push({'###index###': index});
      sampleData.push({'###twitter###': sample.getSampleType() === 'under280'});
      sampleData = [...sampleData, ...sample.getData()];
      mergeTags.push(sampleData);
    })

    if (Utils.isEqualIgnoringType(__this.campaign.config.mergeTags, mergeTags)) {
      return false;
    } else {
      __this.campaign.config.mergeTags = mergeTags;
    }

    return __this.campaign;
  }

  aimi_email_variants.imagesPayloadProcessor = function (requestData) {
    //"imageCollections": [
    // //       "375",
    // //       "134"
    // //     ],
    // //     "manualImages": [],
    // //     "imageTags": [],

    const collections = requestData['campaign-images'] === 'image-collection';

    if (app.isEmpty(__this.campaign.config)) {
      __this.campaign.config = {};
    }

    if (app.isEmpty(__this.campaign.config.imageCollections)) {
      __this.campaign.config.imageCollections = [];
    }

    if (app.isEmpty(__this.campaign.config.imageTags)) {
      __this.campaign.config.imageTags = [];
    }

    if (
        Utils.isEqualIgnoringType(__this.campaign.config.imageCollections, requestData.imageCollections) &&
        Utils.isEqualIgnoringType(__this.campaign.config.imageTags, requestData.imageTags)) {
      return false;
    }

    if (collections) {
      __this.campaign.config.imageCollections = requestData.imageCollections;
      __this.campaign.config.imageTags = [];
    } else {
      __this.campaign.config.imageCollections = [];
      __this.campaign.config.imageTags = requestData.imageTags;
    }

    return __this.campaign;
  }

  aimi_email_variants.categoryPayloadProcessor = function (requestData) {
    const category = requestData.config.category;

    if (app.isEmpty(__this.campaign.config)) {
      __this.campaign.config = {};
    }

    if (app.isEmpty(__this.campaign.config.category)) {
      __this.campaign.config.category = null;
    }

    if (__this.campaign.config.category === category) {
      return false;
    } else {
      if (!app.isEmpty(__this.campaign.posts)) {
        const $modal = app.infoModal(
            'Category Changed',
            'The changes you are making require that your current campaign settings be reset from this point forward. That means if you continue, all posts added or un added from this campaign will be removed. You will be required to fill out all sections required and "Build" this campaign again.',
            {
              saveButton: true,
              saveButtonText: 'Reset Campaign'
            });

        $modal.promise.then(async function (response) {
          if (response.confirm) {
            delete (__this.campaign.config.imageTags);
            delete (__this.campaign.config.blockgroups);
            delete (__this.campaign.config.hashtags);
            delete (__this.campaign.config.imageCollections);
            delete (__this.campaign.config.manualImages);
            delete (__this.campaign.config.mergeTags);
            delete (__this.campaign.config.options);
            delete (__this.campaign.posts);
            delete (__this.campaign.library);
            __this.campaign.config.category = category;

            const $button = response.button;
            const $modal = response.modal;

            app.doButtonAction($button);
            const resetResponse = await app.apis['mdcdot_email_variants'].reset(__this.campaign.id, __this.campaign);
            app.doButtonReset($button);
            $modal.modal('hide');
            aimi_email_variants.view.refresh(__this.campaign.id).then(function (response) {
              __this.nextStep = '#tab_email_variants_block_3';
              aimi_email_variants.saveCallBack(response);
            });
          } else {
            __this.nextStep = null;
          }
        })
        return false;
      } else {
        __this.campaign.config.category = category;
        __this.campaign.campaign = requestData.campaign;
        return __this.campaign;
      }
    }

  }

  aimi_email_variants.settingsPayloadProcessor = function (requestData) {
    const useAimi = requestData.useAimi === 'useAimi';

    if (app.isEmpty(__this.campaign.config.frequency)) {
      __this.campaign.config.frequency = {
        useAimi: !useAimi,
        postTimes: null
      };
    }

    if (__this.campaign.config.frequency.useAimi === useAimi &&
        (!useAimi && !app.isEmpty(requestData["frequency.postTimes"]) && parseInt(requestData["frequency.postTimes"]) === parseInt(__this.campaign.config.frequency.postTimes))
    ) {
      return false;
    } else {
      let frequency = {
        useAimi: useAimi,
        postTimes: useAimi === false ? requestData["frequency.postTimes"] : null,
      };

      __this.campaign.config.frequency = {...__this.campaign.config.frequency, ...frequency};
    }

    return __this.campaign;
  }


  aimi_email_variants.hashTagsPayloadProcessor = function (requestData) {
    if (!app.isEmpty(requestData.hashtags)) {
      // Split the hashtags from the requestData by commas into an array.
      let hashtags = requestData.hashtags.split(',');
      // Remove any duplicate hashtags to ensure uniqueness.
      hashtags = [...new Set(hashtags)];
      // Filter out any empty strings or null values from the array.
      hashtags = hashtags.filter(element => element !== "" && element != null);
      // Map over each hashtag, sanitizing and ensuring each one starts with a '#' character.
      hashtags = hashtags.map(hashtag => '#' + app.sanitizeHashtag(hashtag));
      // Retrieve any existing hashtags from the business profile's configuration.

      if (app.isEmpty(__this.campaign.config)) {
        __this.campaign.config = {};
      }

      if (app.isEmpty(__this.campaign.config.hashtags)) {
        __this.campaign.config.hashtags = [];
      }

      const existingHashtags = __this.campaign.config.hashtags;
      // Combine the existing hashtags with the newly processed ones, avoiding duplicates.
      __this.campaign.config.hashtags = [...existingHashtags, ...hashtags];
    }

    return __this.campaign;
  }

  aimi_email_variants.payloadProcessor = function (requestData) {
    const defaults = {
      startDate: moment().format('YYYY-MM-DD'),
      status: 'incomplete',
      config: {frequency: {autoBuild: false}, imageTab: 'proplus'}
    };


    if (app.isEmpty(requestData.calendar) || app.isEmpty(requestData.name)) {
      return false;
    }

    if (__this.campaign.name === requestData.name && (parseInt(__this.campaign.calendar) === parseInt(requestData.calendar))) {
      return false;
    }

    __this.campaign = Utils.mergeDeep(defaults, __this.campaign);
    __this.campaign = Utils.mergeDeep(__this.campaign, requestData);

    __this.campaign = {...__this.campaign, ...{campaignName: __this.campaign.name}};
    return __this.campaign;
  }


  aimi_email_variants.hashTagsUpdateCallBack = async function (response) {
    // Display a notification with the response message and set the progress to 90%
    app.notifyEl.update({'message': response.message, progress: 90});

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);

    // Refresh the view to display the updated hashtags
    aimi_email_variants.view.refresh(response.id, true).then(function (response) {

    });
  };

  aimi_email_variants.view = {

    refresh: async function (id, onlyFetch = false, section = '#tab_email_variants_block_5') {
      __this.campainEditor.showCategoriesLoader();

      let response = await app.apis['mdcdot_email_variants'].get(id);
      __this.campaign = response;
      this.setTitle(__this.campaign);

      aimi_email_variants.view.renderExistingCampaigns();

      this.setValues(response);

      if (onlyFetch === false) {
        Utils.getTab('#tab_email_variants_block_2').removeClass('disabled');
        Utils.getTab('#tab_email_variants_block_3').removeClass('disabled');
        Utils.getTab('#tab_email_variants_block_4').removeClass('disabled');
        if (!app.isEmpty(response.emails)) {
          this.navigate('#tab_email_variants_block_5');
          Utils.getTab('#tab_email_variants_block_5').removeClass('disabled');
          this.afterBuildMenus().enable();
        } else {
          Utils.getTab('#tab_email_variants_block_5').addClass('disabled');
          this.afterBuildMenus().disable();
        }
      }

      return response;
    },

    highLightSelectedCategory: function () {
      const $selectedCategory = $(':input[name="config[category]"]:checked', __this.$container);
      if ($selectedCategory.length) {
        // Scroll to the element
        $selectedCategory[0].scrollIntoView({behaviour: 'smooth', block: 'center'});
      }
    },

    navigateToNextStep()  {
      const tabs = $(`${__this.topContainer} .menu-content-wrap a[data-bs-toggle='tab']`);
      const activeTab = tabs.filter('.active');
      const nextTab = tabs.eq(tabs.index(activeTab) + 1);
      const activePane = $(`${__this.containerRoot} .tab-pane:visible.active.show`).last();

      if(activePane.length) {
        let form = activePane.find('form');
        if(form.length === 0) {
          form = activePane.parents('.tab-pane.active.show').first().find('form');
        }
        if(form.length) {
          form.find('button[type=submit]').click();
          return form;
        }
      }
      return false;
    },

    navigate(href, checkLastTab = false) {
      if (!app.isEmpty(__this.lastActiveTab) && checkLastTab) {
        const prevTabContent = Utils.getTabContent(__this.lastActiveTab);
        const form = prevTabContent.find('form[name=aimi-campaign]').eq(0);

        const event = new Event('submit', {
          bubbles: true,    // The event will bubble up through the DOM
          cancelable: true  // The event can be canceled
        });

        if (!app.isEmpty(form[0])) {
          form[0].dispatchEvent(event);
        }
      }

      if (app.isEmpty(__this.lastActiveTab) || href !== __this.lastActiveTab) {
        __this.lastActiveTab = href;
      }

      let self = this;

      if (href === '#tab_email_variants_block_1') {
        self.setHeaderTabs([
          {'icon': 'table', 'title': 'Pick A Calendar', 'id': 'tab_pick_a_calendar'}
        ]);

        Utils.createAndShowTab('#tab_email_variants_block_1');

        if (!app.isEmpty(__this.campaignId)) {
          self.setHeaderTabs([
            {'icon': 'table', 'title': 'Pick A Calendar', 'id': 'tab_pick_a_calendar'}
          ]);

          Utils.createAndShowTab('#tab_pick_a_calendar');
          __this.nextStep = '#tab_email_variants_block_2';

        } else {
          Utils.createAndShowTab('#tab_pick_a_calendar');
          __this.nextStep = '#tab_email_variants_block_2';
        }
      }

      if (href === '#tab_pick_a_calendar') {
        Utils.createAndShowTab('#tab_pick_a_calendar');
        __this.nextStep = '#tab_email_variants_block_2';
      }

      if (href === '#tab_email_variants_block_2') {
        self.setHeaderTabs([
          {'icon': 'table', 'title': 'Pick A Category', 'id': 'tab_pick_a_category'}]
        );
        Utils.createAndShowTab('#tab_email_variants_block_2');
        Utils.createAndShowTab('#tab_pick_a_category');
        self.highLightSelectedCategory();
        __this.nextStep = '#tab_email_variants_block_3';
      }

      if (href === '#tab_pick_a_category') {
        Utils.createAndShowTab('#tab_pick_a_category');
        __this.nextStep = '#tab_email_variants_block_3';
      }


      if (href === '#tab_email_variants_block_3') {
        self.setHeaderTabs([
          {'icon': 'list', 'title': 'Content Options', 'id': 'tab_content_options'},
          {'icon': 'table', 'title': 'Samples', 'id': 'tab_samples'},
          {'icon': 'table', 'title': 'Images', 'id': 'tab_images'}
        ]);

        const tab = Utils.createAndShowTab('#tab_email_variants_block_3');
        if (tab.attr('data-hide-tab') === '#tab_samples') {
          self.setHeaderTabs([
            {'icon': 'list', 'title': 'Content Options', 'id': 'tab_content_options'},
            {'icon': 'table', 'title': 'Images', 'id': 'tab_images'}
          ]);
          __this.nextStep = '#tab_images';
        } else {
          __this.nextStep = '#tab_samples';
        }

        Utils.hideTabContent('#tab_samples');
        Utils.hideTabContent('#tab_images');
        Utils.createAndShowTab('#tab_content_options');
      }

      if (href === '#tab_content_options') {
        Utils.createAndShowTab('#tab_content_options');
        __this.nextStep = '#tab_samples';
      }

      if (href === '#tab_samples') {
        Utils.createAndShowTab('#tab_samples');
        __this.nextStep = '#tab_images';
      }

      if (href === '#tab_images') {
        Utils.createAndShowTab('#tab_images');
        __this.nextStep = '#tab_email_variants_block_4';
      }

      if (href === '#tab_email_variants_block_4') {
        self.setHeaderTabs([
          {'icon': 'list', 'title': 'Settings', 'id': 'tab_settings'},
        ]);
        Utils.createAndShowTab('#tab_email_variants_block_4');
        Utils.createAndShowTab('#tab_settings');
        __this.nextStep = '#tab_email_variants_block_5';
      }

      if (href === '#tab_settings') {
        Utils.createAndShowTab('#tab_settings');
        __this.nextStep = '#tab_email_variants_block_5';
      }

      if (href === '#tab_email_variants_block_5') {
        self.setHeaderTabs([
          {'icon': 'list', 'title': 'Wall View', 'id': 'tab_wall_view'},
          {'icon': 'table', 'title': 'Table View', 'id': 'tab_table_view'},
        ]);
        Utils.createAndShowTab('#tab_email_variants_block_5');

        Utils.hideTabContent('#tab_table_view');
        Utils.createAndShowTab('#tab_wall_view');

        __this.nextStep = '#tab_table_view';
      }

      if (href === '#tab_wall_view') {
        Utils.createAndShowTab('#tab_wall_view');
        __this.nextStep = '#tab_table_view';

      }

      if (href === '#tab_table_view') {
        Utils.createAndShowTab('#tab_table_view');
        __this.nextStep = null;
      }

      const emailVariantsModalButton = app.emailVariantsModal.find('.btn-confirm');
      if(app.isEmpty(app.emailVariantsModalButtonOriginalText)) {
        app.emailVariantsModalButtonOriginalText = emailVariantsModalButton.text();
      }
      console.log(__this.nextStep);
      if(__this.nextStep === '#tab_email_variants_block_5' ||  __this.nextStep === '#tab_table_view' || __this.nextStep === null) {
        console.log(app.emailVariantsModalButtonOriginalText);
        emailVariantsModalButton.text( app.emailVariantsModalButtonOriginalText);
      } else if(__this.nextStep === '#tab_settings'){
        emailVariantsModalButton.text("Build Email Variants");
      } else {
        emailVariantsModalButton.text("Next Step");
      }



      if (checkLastTab) {
        __this.nextStep = href;
      }

    },
    getCampaignByCategory: async function (id) {
      const self = this;
      const nextStep = Utils.getTabContent('#tab_email_variants_block_2').find('button[type="submit"]');
      const tabLibraries = Utils.getTab('#tab_email_variants_block_3');
      Utils.getTab('#tab_email_variants_block_4').addClass('disabled');
      nextStep.attr('disabled', 'disabled');
      tabLibraries.addClass(' m-progress m-progress-start');

      __this.aysncRequstsGetCampaignByIndustry = app.apis['mdcdot_email_variants'].getCampaignByCategory(id).done(function (response) {
        const $campaign = $(':input[name=campaign]', __this.$container);
        $campaign.val(response.id);
        tabLibraries.removeClass(' m-progress m-progress-start ');
        Utils.getTab('#tab_email_variants_block_4').removeClass('disabled');
        nextStep.removeAttr('disabled');
        self.buildSamples(JSON.parse(response.samples), [], response.options);
        self.buildBlockGroups(response.blockgroups, [], response.options);
      }).fail(function (response) {

      });
    },
    getCollectionsByCampaign: async function (id) {
      const self = this;
      const tab = Utils.getTab('#tab_email_variants_block_3');
      tab.addClass(' m-progress m-progress-start');
      return __this.aysncRequstsGetCollectionsByCampaign = app.apis['mdcdot_email_variants'].imageCollections(id).done(function (response) {
        tab.removeClass(' m-progress m-progress-start ');

      }).fail(function (response) {

      });
    },
    getCategories: async function (id) {
      const self = this;
      const tab = Utils.getTab('#tab_email_variants_block_2');
      tab.addClass(' m-progress m-progress-start');

      const categories = await __this.campainEditor.renderCategories(id);
      tab.removeClass(' m-progress m-progress-start ');
      return categories;
    },
    buildSamples: function (samples, optionValues, campaignOptions) {
      __this.$samplesContainerUnder280.empty();
      __this.$samplesContainerOver280.empty();
      const self = this;
      const tab = Utils.getTab('#tab_email_variants_block_3');

      if (app.isEmpty(samples)) {
        tab.attr('data-hide-tab', '#tab_samples');
      } else {
        tab.removeAttr('data-hide-tab');

        const businessSamples = _.template(app.templates['business_profile__samples']);
        const over280 = samples.slice(0, 4);
        const under280 = samples.slice(4);

        $.each({'over280': over280, 'under280': under280}, function (key, data) {

          let samplesData = {'prefix': key};
          const $container = key === 'over280' ? __this.$samplesContainerOver280 : __this.$samplesContainerUnder280;
          $.each(data, function (index, sample) {
            const sampleIndex = index + 1;
            let $sample = Sample.parseSample(sample, optionValues, campaignOptions);
            samplesData[`sample${sampleIndex}`] = $sample.join(' ');
          });

          let $businessSamples = $(businessSamples(samplesData));
          $businessSamples.appendTo($container);
        });

        // this.setSampleActiveTab();
      }
    },

    buildBlockGroups(blockGroups, optionValues, campaignOptions) {
      $('.blockgroups-container', __this.$container).empty();

      $.each(campaignOptions, function (index, option) {
        if (parseInt(option.active)) {
          const checkbox = _.template(app.templates['global__checkbox-switch']);
          const $checkbox = $(checkbox({...option, ...{type: 'checkbox', name: `option[${option.tag}]`,}}));
          $('.blockgroups-container', __this.$container).append($checkbox);
        }
      });

      $.each(blockGroups, function (index, blockGroup) {
        let mergeTags = JSON.parse(blockGroup.merge_tags);
        const tmp = {};
        mergeTags.forEach(row => tmp[row.tag] = row);
        mergeTags.filter(mergeTag => {
          mergeTag.blockgroup = blockGroup.block_group;
        })
        mergeTags = tmp;
        $.each(mergeTags, function (mergeTagIndex, mergeTag) {
          if (app.isEmpty(mergeTag['label'])) {
            return;
          }

          const collapaseId = `option-id-${app.generateId()}-${blockGroup.id}`;
          const checkbox = _.template(app.templates['global__checkbox-switch']);
          const $checkbox = $(checkbox({
            ...mergeTag, ...{
              type: 'checkbox',
              name: `switch[${mergeTag.tag}]`,
              collapse: `#${collapaseId}`,
              blockgroup: blockGroup.block_group
            }
          }));
          $('.blockgroups-container', __this.$container).append($checkbox);

          let $sample = Sample.parseSample(blockGroup.sample, optionValues, mergeTags);
          const blockGroupTemplate = _.template(app.templates['global__dynamic-learn-blockgroup']);
          const $blockGroup = $(blockGroupTemplate({
            sample: $sample.join(' '),
            collapaseId: `${collapaseId}`,
            tag: mergeTag.tag
          }));

          $('.blockgroups-container', __this.$container).append($blockGroup);
        });
      });
    },

    afterBuildMenus: function () {
      return {
        enable: function () {
          $('.after-build-menus a, .after-build-menus button').removeClass('disabled');
        },
        disable: function () {
          $('.after-build-menus a, .after-build-menus button').addClass('disabled');
        }
      }
    },

    setTitle: function (campaignData) {
      const title = $('.pg-title');
      if (!app.isEmpty(campaignData)) {
        title.html(campaignData.name);
      } else {
        title.html("New Campaign");
      }
    },

    setPageTitle: function (campaignId) {
      const title = $('.pg-title');
      let campaigns = app.localStorage.getItem('campaigns');
      let campaignData;
      if (!app.isEmpty(campaigns)) {
        campaigns = JSON.parse(campaigns);
        campaignData = campaigns[campaignId];
        this.setTitle(campaignData);
      }
    },

    renderExistingCampaigns: async function (fetch = true, render  = true) {
      let data = {}, aimiEmailCampaigns = {};
      if (fetch) {
        data = await app.apis['mdcdot_email_variants'].list();
        aimiEmailCampaigns = await  app.apis['mdcdot_campaign'].emailVariantsAimiCampaigns();

        // Filter out campaigns which are available in dot instance
        let filterdCampaigns = {};
        _.each(data.campaigns, function(campaign, id) {
          id = parseInt(id);
          aimiEmailCampaigns.aimiEmailCampaignIds.some(function(aimiEmailCampaignId) {
            if(aimiEmailCampaignId === id) {
              filterdCampaigns[id] = campaign;
            }
          })
        });

        data.campaigns = filterdCampaigns;

        app.allEmailVariants = data.campaigns;
      } else {
        data.campaigns = app.allEmailVariants;
      }

      if (render) {
        $(__this.topContainer).find('.sendemailvariant-container').removeClass('d-none')
        const $select = $(__this.topContainer).find('select[name="SendVariant"]');
        const emailsDropdown = new DropdownUtility($select);
        if(!app.isEmpty(data.campaigns)) {
          emailsDropdown.populateDropdown(_.values(data.campaigns), "id", "name", "Create New Email Variant");
        } else {
          emailsDropdown.populateDropdown([], "id", "name", "Create New Email Variant");
        }

        $select.select2({
          theme: 'bootstrap-5'
        });

        if (!app.isEmpty(__this.campaignId)) {
          $select.val(__this.campaignId).trigger('change.select2');
        }
      }

      return data;
    },

    init: async function (campaignId, containerRoot, topContainer) {
      this.setPageTitle(campaignId);

      const self = this;
      __this.topContainer = topContainer;

      const $modalBody = $(".modal-body", $(__this.topContainer));

      const progress = new ProgressBar($modalBody.find(".modal-body"));
      progress.start();

      // Loads the email variants view and initializes the modal
      const url = Utils.addParamToURL("/load-view", {path: "dot/campaign/email-variants-view.html.twig"});

      const response = await app.getRequest(url, {}, function () {
      }, function () {
      }, '', false);

      $modalBody.html(response);

      const forms = $modalBody[0].querySelectorAll(".needs-validation");
      app.addValidationToForms(forms);

      // Now we have the dom
      __this.$container = $(containerRoot);
      __this.containerRoot = containerRoot;
      __this.campaignId = campaignId;

      app.postActionsContext = `campaign-${campaignId}`;

      __this.$form = $('form[name=aimi-campaign]');

      await self.renderExistingCampaigns(false, true);

      __this.campainEditor = new EmailVariantsEditor(app, __this.$form);

      __this.buildRange = $('input[name=buildRange]', __this.$form);
      __this.inputCalendar = $(':input[name=calendar]', __this.$form);

      // Init Samples
      aimi_samples.init();

      // Sample containers for character count variations
      __this.$samplesContainerOver280 = $('.samples-container-over280', __this.$form);
      __this.$samplesContainerUnder280 = $('.samples-container-under280', __this.$form);

      Utils.getTab('#tab_email_variants_block_2').addClass('disabled');
      Utils.getTab('#tab_email_variants_block_3').addClass('disabled');
      Utils.getTab('#tab_email_variants_block_4').addClass('disabled');
      Utils.getTab('#tab_email_variants_block_5').addClass('disabled');
      Utils.getTab('#tab_email_variants_block_6').addClass('disabled');

      self.afterBuildMenus().disable();

      // If in edit mode
      if (__this.campaignId) {
        const currentStep = app.localStorage.getItem('next-step') || '#tab_email_variants_block_1';
        app.localStorage.removeItem('next-step');
        self.navigate(currentStep);

        self.refresh(campaignId).then(function (response) {

        });
      } else {
        // Set default header tabs and show the first tab
        self.navigate('#tab_email_variants_block_1')
        __this.campaign = {};
        app.localStorage.setItem('next-step', '#tab_email_variants_block_2');
      }

      __this.aysncRequstsPickACalendar = app.apis['calendar'].fetch().then(function (response) {
        __this.calendars = response;

        const $formControlLoader = __this.inputCalendar.closest('.form-control-loader');
        $.each(response, function (index, value) {
          const $option = $('<option />').attr('value', value.id).html(value.name);
          $option.appendTo(__this.inputCalendar)
        });
        $formControlLoader.removeClass('m-progress');
        __this.inputCalendar.select2({
          theme: 'bootstrap-5'
        });
      }, function (response) {

      });

      app.initRadioSwitches(__this.$container);

      const tabEventManager = new EventManager('email-variants-view', `.sub-menu a[data-bs-toggle='tab'], ${__this.containerRoot} .header-tabs-start a[data-bs-toggle='tab']`);
      const campaignImagesEventManager = new EventManager('email-variants-view-action', `[data-campaign-action]`);
      const categoryManager = new EventManager('email-variants-view', `${__this.containerRoot} :input[name="config[category]"]`);
      const calendarManager = new EventManager('email-variants-view', `${__this.containerRoot} :input[name="calendar"]`);
      const buildCampaignManager = new EventManager('email-variants-view', `${__this.containerRoot} .btn-build-email-variants`);
      const switchEmailVariantsCampaign = new EventManager('email-variants-view', `${__this.topContainer} [data-campaign-action]`);
      const emailVariantsCampaign = new EventManager('email-variants-view-actions', `${__this.topContainer} [data-email-variants-action]`);

      buildCampaignManager.addEventListener('click', function () {
        app.localStorage.setItem('build-email-variants', JSON.stringify({id: __this.campaignId}));
      });

      categoryManager.addEventListener('change', function () {
        const id = $(this).val();
        self.getCampaignByCategory(id).then(function () {

        });
      })

      calendarManager.addEventListener('change', function () {
        const id = $(this).val();
        const calendar = __this.calendars[id];
        __this.aysncRequstsGetCategories = self.getCategories(calendar.persona_id).then(function (response) {

        });
      })

      tabEventManager.addEventListener('click', function (e) {
        let $this = $(this);
        const href = $this.attr('href');
        self.navigate(href, true);
      });


      switchEmailVariantsCampaign.addEventListener('change', function () {
        const $this = $(this);
        const action = $this.data('campaign-action');

        if (action === 'render-email-campaign') {
          const id = app.isEmpty($this.val()) ? null : $this.val();
          aimi_email_variants.view.init(id, "[data-email-variants-view-root]", ".modal-email-variants-editor");
        }
      });

      console.log(emailVariantsCampaign);

      emailVariantsCampaign.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $this = $(this);
        const action = $this.data('email-variants-action');

        if(action === 'view') {
          previewEmailVariant($this.data('id'));
        }
      })

      function campaignAction(e) {
        e.preventDefault();
        e.stopPropagation();

        const $this = $(this);
        const action = $this.data('campaign-action');

        if (action === 'add-collection-images') {
          const $modal = app.infoModal('Image Library', '', {
            id: 'imageLibraryModal',
            saveButton: true,
            saveButtonText: 'Add to Campaign',
            footerText: '<span class="fw-semibold"><span class="text-primary"> Note: </span> Please select collections to add to campaign</span>',
            dialogClass: 'modal-full modal-image-library '
          });

          const page = _.template(app.templates['image_library__modal']);
          const $imageModal = $(page());
          const $modalBody = $('.modal-body', $modal);
          $imageModal.appendTo($modalBody);

          const $tabContent = $imageModal.find('.tab-content');

          aimi_image_library.init($tabContent, '.modal-image-library', {
            collections: {'addButton': true, disabled: false, removeButton: false}, activeMenuIndex: 1
          });

          $modal.promise.then(function (response) {
            const $container = response.modal;
            if (response.confirm) {
              const $cards = $container.find('.infinite-item');
              const collections = [];
              $cards.each(function () {
                const $this = $(this);
                const $input = $this.find('input');
                if ($input.is(":checked")) {
                  console.log($this.data('id'));
                  collections.push(window['imageCollections'][$this.data('id')]);
                }
              });
              $container.modal('hide');
              __this.campainEditor.renderImageCollections(collections);

            }
          })
        }

        if (action === 'view-collection') {
          const $modal = app.infoModal('Image Library', '', {
            id: 'imageLibraryModal',
            saveButton: true,
            saveButtonText: 'Add to Campaign',
            footerText: '<span class="fw-semibold"><span class="text-primary"> Note: </span> Please select collections to add to campaign</span>',
            dialogClass: 'modal-full modal-image-library '
          });

          const page = _.template(app.templates['image_library__modal']);
          const $imageModal = $(page());
          const $modalBody = $('.modal-body', $modal);
          $imageModal.appendTo($modalBody);

          const $tabContent = $imageModal.find('.tab-content');

          aimi_image_library.init($tabContent, '.modal-image-library', {
            collections: {'addButton': true, disabled: false},
            activeMenuIndex: 1,
            viewCollection: $this.data('image-collection')
          });

          $modal.promise.then(function (response) {
            const $container = response.modal;
            if (response.confirm) {
              const $cards = $container.find('.infinite-item');
              const collections = [];
              $cards.each(function () {
                const $this = $(this);
                const $input = $this.find('input');
                if ($input.is(":checked")) {
                  collections.push(window['imageCollections'][$this.data('id')]);
                }
              });
              $container.modal('hide');
              __this.campainEditor.renderImageCollections(collections);
            }
          })
        }


        if (action === 'add-tagged-images') {
          const $modal = app.infoModal('Image Library', '', {
            id: 'imageLibraryModal',
            saveButton: true,
            saveButtonText: 'Add to Campaign',
            dialogClass: 'modal-full modal-image-library '
          });

          const page = _.template(app.templates['image_library__modal']);
          const $imageModal = $(page());
          const $modalBody = $('.modal-body', $modal);
          $imageModal.appendTo($modalBody);

          const $tabContent = $imageModal.find('.tab-content');

          aimi_image_library.init($tabContent, '.modal-image-library', {
            tags: {'addButton': true}, activeMenuIndex: 2
          });

          $modal.promise.then(function (response) {
            const $container = response.modal;
            if (response.confirm) {
              const $cards = $container.find('.tag-row');
              const tags = [];
              $cards.each(function () {
                const $this = $(this);
                if ($this.hasClass("selected")) {
                  tags.push(window['imageTags'][$this.data('id')]);
                }
              });
              $container.modal('hide');
              __this.campainEditor.renderImageTags(tags);
            }
          })
        }

        if (action === 'view-tag') {
          const $modal = app.infoModal('Image Library', '', {
            id: 'imageLibraryModal',
            saveButton: true,
            saveButtonText: 'Add to Campaign',
            dialogClass: 'modal-full modal-image-library '
          });

          const page = _.template(app.templates['image_library__modal']);
          const $imageModal = $(page());
          const $modalBody = $('.modal-body', $modal);
          $imageModal.appendTo($modalBody);

          const $tabContent = $imageModal.find('.tab-content');

          aimi_image_library.init($tabContent, '.modal-image-library', {
            tags: {'addButton': true}, activeMenuIndex: 2, viewTag: $this.data('image-tag')
          });

          $modal.promise.then(function (response) {
            const $container = response.modal;
            if (response.confirm) {
              const $cards = $container.find('.tag-row');
              const tags = [];
              $cards.each(function () {
                const $this = $(this);
                if ($this.hasClass("selected")) {
                  tags.push(window['imageTags'][$this.data('id')]);
                }
              });
              $container.modal('hide');
              __this.campainEditor.renderImageTags(tags);
            }
          })
        }

        const clearAndRebuildMessage = 'Are you sure you want to rebuild this campaign? All scheduled or unscheduled posts will be replaced.';
        const rebuildUnscheduledMessage = 'Are you sure you want to rebuild this campaign? All unscheduled posts will be replaced.';
        const updatePostsMessage = 'Are you sure you want to update all your posts? All your posts will be updated with your changes.';

        if (action === 'update-posts') {
          app.confirm('Update Posts', updatePostsMessage).then(function (response) {
            const $button = response.button;
            const confirm = response.confirm;
            const $modal = response.modal;

            // If the user confirms the deletion, proceed with the delete operation.
            if (confirm === true) {
              app.doButtonAction($button);
              const responsePosts = app.apis['mdcdot_email_variants'].build(__this.campaignId, true, true).then(function () {
                app.doButtonReset($button);
                app.hideModal($modal);
                aimi_email_variants.view.refresh(__this.campaignId);
              });
            }
          })
        }


        if (action === 'clear-and-rebuild') {
          app.confirm('Clear & Rebuild', clearAndRebuildMessage).then(function (response) {
            const $button = response.button;
            const confirm = response.confirm;
            const $modal = response.modal;

            // If the user confirms the deletion, proceed with the delete operation.
            if (confirm === true) {
              app.doButtonAction($button);
              const responsePosts = app.apis['mdcdot_email_variants'].build(__this.campaignId, false, false).then(function () {
                app.doButtonReset($button);
                app.hideModal($modal);
                aimi_email_variants.view.refresh(__this.campaignId);
              });
            }
          })

        }


      }

      campaignImagesEventManager.addEventListener('click', campaignAction);

      // Initialize custom scrollbars
      $('.nicescroll-bar').each(function () {
        app.initSimpleBar(this);
      });

      return new Promise((resolve, reject) => {

      });
    },
    setHeaderTabs: function (tabs) {
      const $container = $(`${__this.topContainer} .header-tabs-start`);
      $container.empty();
      _.each(tabs, function (tab) {
        const page = _.template(app.templates['global__header-nav-item']);
        const $page = $(page(tab));
        $page.appendTo($container);
      });
    },


    setPreferences(preferences) {
      preferences = _.indexBy(preferences, 'tag');

      $('[data-tag]').each(function () {
        const $this = $(this);
        const $tag = $this.attr('data-tag');
        let elementType = $this[0].type;

        // Check if textarea or select
        if (app.isEmpty(elementType)) {
          elementType = $this[0].tagName;
        }

        if (!app.isEmpty(preferences[$tag]) && !app.isEmpty(preferences[$tag]['value'])) {
          const value = preferences[$tag]['value'];
          const sampleType = $this.attr('data-type');
          let $collapse = false;

          if (elementType === 'checkbox') {
            $this.prop('checked', value);
          }

          if (app.isEmpty(sampleType) && (elementType === 'text' || elementType === 'textarea')) {
            $this.val(value);
            $collapse = $this.closest('[data-collapse]');
          }

          if (!app.isEmpty(sampleType) && sampleType === 'sample' && preferences[$tag]['enabled']) {
            Sample.setElementValue($this, value);
            $collapse = $this.closest('[data-collapse]');
          }

          if ($collapse.length) {
            const $checkboxSwitch = $(`[data-tag="${$collapse.attr('data-collapse')}"]`);
            Utils.setSwitchVal($checkboxSwitch, true);
          }
        }
      })
    },

    setSamples: function (mergeTags) {
      const groupedMergeTags = getSamplesData(mergeTags);
      _.each(groupedMergeTags, function (mergeTagsByType, type) {
        _.each(mergeTagsByType, function (mergeTags, index) {
          if (!app.isEmpty(mergeTags)) {
            const sampleIndex = parseInt(index) + 1;
            const sampleNav = $(`[data-sample-container="${type}__${sampleIndex}"]`);
            const sample = $(sampleNav.attr('data-bs-target'));

            sample.find('[data-tag]').each(function () {
              const $this = $(this);
              const $tag = $this.attr('data-tag');
              const sampleType = $this.attr('data-type');

              if (!app.isEmpty(mergeTags[$tag])) {
                const value = mergeTags[$tag]['value'];
                if (!app.isEmpty(sampleType) && sampleType === 'sample') {
                  Sample.setElementValue($this, value);
                }
              }
            });

            const sampleObject = new Sample(sample);
            sampleObject.validate();
          }
        });
      });
    },

    build: async function (values = []) {
      const self = this;
      const $postsContainer = $('[data-email-variants-container]', __this.$container);
      const $tableContainer = $('[data-email-variants-table]', __this.$container);

      __this.observerManager = new ImageObserverManager(app, '.posts-grid-item', 'calendar-card-width', $postsContainer);
      // To observe resizing for an element
      __this.observerManager.observeResize($postsContainer[0]);

      __this.listMananger = new EmailVariantsList(app, $postsContainer, 'dot_email__library-card', false);

      __this.listMananger.renderListByEmails(values).then(function () {
        __this.listMananger.renderTableView($tableContainer, 'dot_email__library-row', values);
      });


      return __this.listMananger;
    },

    setViaBusinessProfile(appCampaign) {
      if (
          !app.isEmpty(appCampaign) &&
          !app.isEmpty(appCampaign.accountConfig)
      ) {
        let accountConfig = appCampaign.accountConfig;
        let personaTagValue = `via account settings :<span class="fw-semibold text-success"> ${accountConfig.firstName}  ${accountConfig.lastName} </span>`;
        personaTagValue = `${personaTagValue}`;
        $('[data-append-via-business-profile="{FIRST_NAME|}"]').html(personaTagValue);
      }

      if (
          !app.isEmpty(appCampaign) &&
          !app.isEmpty(appCampaign.personaConfig) &&
          !app.isEmpty(appCampaign.personaConfig.options)
      ) {
        let personaOptions = appCampaign.personaConfig.options;
        personaOptions = _.indexBy(personaOptions, 'tag');
        $('[data-append-via-business-profile]').each(function () {
          let $this = $(this);
          let personaTag = $this.attr('data-append-via-business-profile');
          if (!_.isUndefined(personaOptions[personaTag]) && (_.isUndefined(personaOptions[personaTag].enabled) || personaOptions[personaTag].enabled === true)) {
            let personaTagValue = personaOptions[personaTag].value;
            if (personaTag === '{FIRST_NAME|}' && !app.isEmpty(personaOptions[personaTag].value)) {
              personaTagValue = personaOptions[personaTag].value + ' ' + personaOptions['{LAST_NAME|}'].value;
            }
            if (personaTag === '{NUMBER|}') {
              personaTagValue = personaOptions['{CALL_OPTION|}'].value + ' ' + personaOptions[personaTag].value;
            }
            if (!app.isEmpty(personaTagValue)) {
              personaTagValue = `<span class="fw-semibold text-success">${personaTagValue}</span>`;
              $this.html(`via business profile : ${personaTagValue}`);
            }
          }
        });
      }
    },

    setValuesSetting(values) {
      const settings = values.config;
      __this.inputDays = $('input[name="days[]"]', __this.$form);
      __this.inputTime = $('input[name="time[]"]', __this.$form);
      __this.inputFrequencyPostTimes = $('input[name="frequency.postTimes"]', __this.$form);

      if (!app.isEmpty(settings.frequency)) {
        if (settings.frequency.useAimi) {
          Utils.setSwitchVal($(':input[name="useAimi"][value="useAimi"]'), true, true);
        } else {
          Utils.setSwitchVal($(':input[name="useAimi"][value="custom"]'), true, true);
          __this.inputFrequencyPostTimes.val(settings.frequency.postTimes);
        }
      }
    },

    setValues(values) {
      const self = this;
      const $postsContainer = $('[data-posts-container]', __this.$container);
      const $name = $(':input[name="name"]', __this.$container);
      $name.val(values.name);

      this.setViaBusinessProfile(values);

      // Hashtags, Graphics
      let options, mergeTags, blockgroups, imageCollections, imageTags;
      if (!app.isEmpty(values) && !app.isEmpty(values.config)) {
        if (!app.isEmpty(values.config.options)) {
          options = values.config.options;
        }

        if (!app.isEmpty(values.config.mergeTags)) {
          mergeTags = values.config.mergeTags;
        }

        if (!app.isEmpty(values.config.blockgroups)) {
          blockgroups = values.config.blockgroups;
        }

        if (!app.isEmpty(values.config.imageCollections)) {
          imageCollections = values.config.imageCollections;
        }

        if (!app.isEmpty(values.config.imageTags)) {
          imageTags = values.config.imageTags;
        }
      }

      this.setValuesSetting(values);

      __this.aysncRequstsPickACalendar.then(function () {

        __this.inputCalendar.val(values.calendar).trigger('change');

        __this.aysncRequstsGetCategories.then(async function () {
          const $category = $(':input[name="config[category]"]', __this.$container);

          if (!app.isEmpty(values.config) && !app.isEmpty(values.config.category)) {
            const selectedCategory = $category.filter((index, category) => {
              return category.value.toString() === values.config.category.toString()
            }).eq(0);

            selectedCategory.prop('checked', true);
            selectedCategory.trigger('change');

            self.highLightSelectedCategory();

            __this.aysncRequstsGetCampaignByIndustry.then(function () {
              if (!app.isEmpty(mergeTags)) {
                self.setSamples(mergeTags);
              }

              if (!app.isEmpty(options)) {
                self.setPreferences(options);
              }

              if (!app.isEmpty(blockgroups)) {
                self.setPreferences(blockgroups);
              }
            })

            if (!app.isEmpty(imageCollections)) {
              const $campaignImages = $(":input[name=campaign-images][value=image-collection]", __this.$container);
              Utils.setSwitchVal($campaignImages, true);
              __this.campainEditor.renderImageCollections(imageCollections);
            }

            if (!app.isEmpty(imageTags)) {
              let response = await app.apis['image-tags'].fetch();
              let allImageTags = response.result;

              const selectedImageTags = allImageTags.filter(obj => {
                obj.tag = {'class': Utils.getTagClass(), tag: obj.tag};
                return imageTags.includes(obj.id);
              })

              const $campaignImages = $(":input[name=campaign-images][value=custom]", __this.$container);
              Utils.setSwitchVal($campaignImages, true);
              __this.campainEditor.renderImageTags(selectedImageTags);
            }
          }
        })
      });

      // Settings
      // Range
      const $startDay = $(":input[name=startDay]", __this.$container);
      const $endDay = $(":input[name=endDay]", __this.$container);
      const $buildRange = $(":input[name=buildRange]", __this.$container);
      const $campaignSettingAutoBuild = $(":input[name=campaign-build-setting][value=auto-build]", __this.$container);
      const $campaignSettingOneTime = $(":input[name=campaign-build-setting][value=one-time]", __this.$container);

      if (!app.isEmpty(values.config.startDate)) {
        if (values.config.startDate.includes('-') && values.config.endDate.includes('-')) {
          __this.easePick.setStartDate(values.config.startDate);
          __this.easePick.setEndDate(values.config.endDate);
          Utils.setSwitchVal($campaignSettingOneTime, true);
        } else {
          $startDay.val(parseInt(values.config.startDate)).trigger('change');
          $endDay.val(parseInt(values.config.endDate)).trigger('change');
          Utils.setSwitchVal($campaignSettingAutoBuild, true);
        }
      }

      let $imageTab;
      if (app.isEmpty(values.config.imageTab)) {
        $imageTab = $(`:input[name=imageTab]`, __this.$container).eq(0);
      } else {
        $imageTab = $(`:input[name=imageTab][value="${values.config.imageTab}"]`, __this.$container);
      }
      $imageTab.prop('checked', true);

      // Build
      aimi_email_variants.view.build(values);
    }
  }
}(window.aimi_email_variants = window.aimi_email_variants || {}, jQuery, PreBuilt));